import { has, isEmpty } from 'lodash';

import { FilterKind } from '#components/ui/multipleFilters/types';

import { evaluatedOptions } from './evaluatedOptions';
import { flagSdkOptions } from './flagSdkOptions';
import type { FlagFilters } from './records/FlagFilters';

/* Note: This function removes bad values if the user edits the filter query string manually.
  We are removing filters with specific enum value. Boolean filters automatically evaluate to false if
  a bad value is given. The tags filter works with any value so is not included here, similarly the
  maintainerId (or maintainerTeamKey) must be a valid id (or key), so a bad value will be applied,
  but the user can then chose a validId/key from the filter dropdown in the toolbar.
*/
export const removeInvalidFilters = (filters: FlagFilters) => {
  let updatedFilters = filters;

  if (!isEmpty(updatedFilters.evaluated) && !has(evaluatedOptions, updatedFilters.evaluated || '')) {
    updatedFilters = updatedFilters.clearFilter(FilterKind.EVALUATED);
  }

  if (!isEmpty(updatedFilters.sdkAvailability) && !has(flagSdkOptions, updatedFilters.sdkAvailability || '')) {
    updatedFilters = updatedFilters.clearFilter(FilterKind.SDKAVAILABILITY);
  }

  filters.getFilters().forEach((filter) => {
    if (filter.isInvalidFilter()) {
      updatedFilters = updatedFilters.clearFilter(filter.kind);
    }
  });
  return updatedFilters;
};
